import { Instance, Instances, useGLTF, useTexture } from '@react-three/drei';
import { useEffect, useMemo, useRef, useState } from 'react';
import * as THREE from 'three';
useGLTF.preload('/env/darkGreen.glb');
useTexture.preload('/env/secondsmalltree.webp');


export function DarkGreen({ jsonFile }) {
  const { nodes } = useGLTF('/env/darkGreen.glb', true, (error) => {
    console.error('Failed to load model', error)
  })

  // Load and configure the DarkGreen texture
  const DarkGreenTexture = useTexture('/env/secondsmalltree.webp')
  DarkGreenTexture.colorSpace = THREE.SRGBColorSpace
  DarkGreenTexture.flipY = false
  DarkGreenTexture.generateMipmaps = false
  DarkGreenTexture.channel = 1

  // Create a static MeshBasicMaterial
  const material = useMemo(
    () =>
      new THREE.MeshBasicMaterial({
        toneMapped: false,
        map:DarkGreenTexture, 
        side:THREE.DoubleSide,
        // alphaTest:.5
      }),
    []
  )

  // State to store instance data
  const [data, setData] = useState([])

  useEffect(() => {
    // Fetch JSON file
    fetch(jsonFile)
      .then((response) => response.json())
      .then((jsonData) => {
        // Convert JSON object into an array of entries
        const parsedData = Object.values(jsonData).map((entry) => ({
          position: mapAxes(entry.position || [0, 0, 0]),
          scale: entry.scale || [1, 1, 1],
          rotation: mapRotation(entry.rotation || [0, 0, 0]),
        }))
        setData(parsedData)
      })
      .catch((error) => console.error('Failed to load JSON data:', error))
  }, [jsonFile])

  return (
    data.length > 0 && (
      <Instances
        range={data.length} // Dynamic range based on data length
        geometry={nodes.mainDarkGreen.geometry} // Adjust to the appropriate geometry key
        material={material}
      >
        {data.map((props, i) => (
          <FernPlant key={i} {...props} />
        ))}
      </Instances>
    )
  )
}

function FernPlant({ position, scale, rotation }) {
  const ref = useRef()
  return (
    <group
      position={position}
      scale={scale}
      rotation={rotation}
    >
      <Instance ref={ref} />
    </group>
  )
}

// Function to remap Blender axes to Three.js axes
function mapAxes([x, y, z]) {
  return [x, z, -y] // Remap Y to Z and Z to -Y
}

// Function to remap Blender rotation axes to Three.js
function mapRotation([rx, ry, rz]) {
  return [rx, rz, -ry] // Remap Y to Z and Z to -Y
}
